
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const initialState = {
    isLoading: false,

    // U_ETDS ile alakalı
    isLoadingExcel: false,
    isLoadingUETDSSend: false,
    isLoadingUpdateUETDS: false,
    isLoadingCreateUETDS: false,
    isLoadingDeleteUetds: false,
    isLoadingUpdateUETDSAndSend: false,
    isLoadingUpdateUETDSAndSendDanger: false,

    UETDSList: null,
    UETDSCount: null,
    UETDSItemData: null,

    statusCodeGetUETDS: null,
    statusCodeSendUETDS: null,
    statusCodeAddUETDS: null,
    statusCodeAddUETDSDanger: null,
    statusCodeUpdateUETDS: null,
    statusCodeUpdateUETDSDanger: null,

 

    // egeyurt iletişimle alakalı
    egeyurtIletisimList: null,
    egeyurtIletisimItemData: null,

    isLoadingAddEgeyurtIletisimItem: false,
    isLoadingGetEgeyurtIletisim: false,
    isLoadingUpdateEgeyurtIletisimItem: false,
    isLoadingDeleteEgeyurtIletisimItem: false,


    // Günlük Fatura ve Detay Yükleme
    faturaImage:null,
    isLoadingGetFaturaImage: false,
    isLoadingFaturaYukle: false,
    isLoadingDetayYukle: false,    // araç belge aktiflik kontrol


    //! garaj yogunluk
    garajYogunlukList:[],
    isLoadingGetGarajYogunluk: false,

    //! garajDetay
    garajDetayData: [],
    isLoadingGarajDetay: false,

    //! bu tamamen saçma sapan bir animasyon eklemek için garaj detay sayfasına (detay güncellendiğinde güncellenen verinin sayfada gösterilmesi çin)
    isUpdatedGarajDetay:false,

    //! garajla alakalı 
    garajItemData: null,

    // Yük Listesi Başlık ve Açıklama
    anasayfaDuyurular: null,
    anasayfaBaslik: null,
    anasayfaDuyuruMessageItemData: null,

    isLoadingGetAnasayfaDuyurular: false,    
    isLoadingGetAnasayfaBaslik: false,       
    isLoadingUpdateAnasayfaBaslik: false,    
    isLoadingCreateAnasayfaDuyuru: false,    
    isLoadingUpdateAnasayfaDuyuru: false,    
    isLoadingDeleteAnasayfaDuyuru: false,    

    seferMaliyetDetayItem: null,


    // genel
    isError: false,
    message:null,

    destekGeriBildirimDetayItem: null,


}

//! unId varsa tehlikeki, unId null ise normal
export const getUETDS = createAsyncThunk("admin/getUETDS", async({currentPage=1,isEgeApproved=false, bosaltmaIlAdi="",yuklemeIlAdi="",plaka1="",TCKimlikNo1=""},thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/UETDS/GetUetds10by10?currentPage=${currentPage}&&isEgeApproved=${isEgeApproved}&&bosaltmaIlAdi=${bosaltmaIlAdi}&&yuklemeIlAdi=${yuklemeIlAdi}&&plaka1=${plaka1}&&TcKimlikNo1=${TCKimlikNo1}`)
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const sendUETDS = createAsyncThunk("admin/sendUETDS", async(id, thunkApi)=> {
    try {

        const {data} = await axiosInstance.post(`/UETDS/SendUetds?id=${id}`,"")
        if (data.statusCode === 200) {
            toast.success('Yük bildirimi başarı ile gönderildi.', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error('Bir hata oluştu, lütfen daha sonra tekrar deneyin.', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        return data

    } catch (error) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

// normal yük bildirim için
export const addUETDS = createAsyncThunk("admin/addUETDS", async(UETDSYUK, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/AddUETDS`, UETDSYUK)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla oluşturuldu.", routePath: "/admin/u-etds-yuk-bildirimi", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", routePath: "/admin/u-etds-yuk-bildirimi", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

// tehlikeki yük bildirim içiin
export const addUETDSDanger = createAsyncThunk("admin/addUETDSDanger", async(UETDSYUK, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/AddUETDSTehlikeli`, UETDSYUK)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla oluşturuldu.", routePath: "/admin/u-etds-yuk-bildirimi", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", routePath: "/admin/u-etds-yuk-bildirimi", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})
  
export const updateUETDS = createAsyncThunk("admin/updateUETDS", async(UETDSYUK, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/UpdateUetds`, UETDSYUK)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const updateUETDSDanger = createAsyncThunk("admin/updateUETDSDanger", async(UETDSYUK, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/UpdateUetdsTehlikeli` , UETDSYUK)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla güncellendi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


export const updateUETDSAndSend = createAsyncThunk("admin/updateUETDSAndSend", async(UETDSYUK, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/SendUetdsAndUpdate`, UETDSYUK)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla güncellendi ve gönderildi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const updateUETDSAndSendDanger = createAsyncThunk("admin/updateUETDSAndSendDanger", async(UETDSYUK, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/SendUetdsTehlikeliAndUpdate`, UETDSYUK)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla güncellendi ve gönderildi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteUetds = createAsyncThunk("admin/deleteUetds", async({id}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/UETDS/Delete?id=${id}`, "_")
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "U-ETDS yük kaydı başarıyla silindi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const getUetdsExcel = createAsyncThunk("admin/getUetdsExcel", async(_, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/UETDS/GetUetdsFromDatabaseToExcel`)
        
        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)

    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getUetdsExcelSpecial = createAsyncThunk("admin/getUetdsExcelSpecial", async(password, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/UETDS/GetUetdsFromDatabaseToExcel2?password=${password}`)
        if(data.data.data){
            const link = document.createElement('a');
            link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)
            thunkApi.dispatch(showModal(null))
        }

    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! iletişim
export const addEgeyurtIletisimItem = createAsyncThunk("admin/addEgeyurtIletisimItem", async(iletisimItem, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/user/AddContact` , iletisimItem)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Egeyurt iletişim birimi başarıyla oluşturuldu", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const getEgeyurtIletisim = createAsyncThunk("admin/getEgeyurtIletisim", async(_, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`${process.env.REACT_APP_API_URI}/user/GetContactNumbers` )
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateEgeyurtIletisimItem = createAsyncThunk("admin/updateEgeyurtIletisimItem", async(iletisimItem, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`${process.env.REACT_APP_API_URI}/user/UpdateContact` , iletisimItem)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Egeyurt iletişim birimi başarıyla güncellendi", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteEgeyurtIletisimItem = createAsyncThunk("admin/deleteEgeyurtIletisimItem", async(id, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/user/DeleteContact` , id)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Egeyurt iletişim birimi başarıyla Kaldırıldı", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


export const getFaturaImage = createAsyncThunk("admin/getFaturaImage", async(_, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/uetds/GetFaturaImage`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const faturaYukle = createAsyncThunk("admin/faturaYukle", async(file, thunkApi)=> {
    try {
        
        const myFile = new FormData();
        myFile.append('file',file);
        const {data} = await axiosInstance.post(`/auth/FaturaYukle` , myFile)
        if(data.statusCode === 200){
            //! bu getFaturaImage kesin gerekli çağırılmalı mı bimiyorum
            thunkApi.dispatch(getFaturaImage())
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Fatura başarıyla yüklendi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const aracBelgeAktiflikKontrol = createAsyncThunk("admin/aracBelgeAktiflikKontrol", async(file, thunkApi)=> {
    try {
        
        const myFile = new FormData();
        myFile.append('file',file);
        const {data} = await axiosInstance.post(`/truckTrailer/AracBelgeAktiflikKontrol` , myFile)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Belge başarıyla yüklendi", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

//! ---------------------------------------------------------------------------------------------------------
export const getAnasayfaDuyurular = createAsyncThunk("admin/getAnasayfaDuyurular", async(_, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/load/AnaSayfaDuyurularıGetir`)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const getAnaSayfaBaslik = createAsyncThunk("admin/getAnaSayfaBaslik", async(_, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/load/BasliklariGetir`)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const updateAnasayfaBaslik = createAsyncThunk("admin/updateAnasayfaBaslik", async(baslikData, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.post(`/load/BaslikGuncelle` , baslikData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Başlık başarıyla güncellendi", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const createAnasayfaDuyuru = createAsyncThunk("admin/createAnasayfaDuyuru", async(newDuyuru, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/load/AnaSayfaDuyuruEkle` , newDuyuru)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Duyuru Mesajı başarıyla yüklendi", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const updateAnasayfaDuyuru = createAsyncThunk("admin/updateAnasayfaDuyuru", async(updatedDuyuru, thunkApi)=> {
    try {
        const token = thunkApi.getState().auth.token
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
        const {data} = await axiosInstance.post(`/load/DuyuruGuncelle` , updatedDuyuru)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Duyuru Mesajı başarıyla güncellendi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteAnasayfaDuyuru = createAsyncThunk("admin/deleteAnasayfaDuyuru", async(deletedDuyuru, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/load/DuyuruSil` , deletedDuyuru)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Duyuru Mesajı başarıyla silindi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})
//! ---------------------------------------------------------------------------------------------------------


export const getGarajYogunluk = createAsyncThunk("admin/getGarajYogunluk", async(_, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/OnlineGarageProcesses/GetLatestGarageDensitiesByBranch`)
        return data
    } catch (error) {
        // thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


export const getGarajDetay = createAsyncThunk("admin/getGarajDetay", async(id, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/OnlineGarageProcesses/GetGarageDensitiesByBranch?branchId=${id}&&isWeb=true`)
        return data
    } catch (error) {
        // thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


export const updateGarajStats = createAsyncThunk("admin/updateGarajStats", async(item, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/OnlineGarageProcesses/AddGarageDensity`,item)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Garaj yoğunlukları başarı ile güncellendi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
            thunkApi.dispatch(getGarajYogunluk())
        }
        return data
    } catch (error) {
        // thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})






const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        getUETDSItemData: (state,action)=> {
            state.UETDSItemData = action.payload
        },

        getEgeyurtIletisimItemData: (state,action)=> {
            state.egeyurtIletisimItemData = action.payload
        },
        getAnasayfaDuyuruMessageItemData: (state, action) => {
            state.anasayfaDuyuruMessageItemData = action.payload
        },
        resetStatusCode: (state)=> {
            state.statusCodeGetUETDS = null
            state.statusCodeSendUETDS = null
            state.statusCodeAddUETDS = null
            state.statusCodeAddUETDSDanger = null
            state.statusCodeUpdateUETDS = null
            state.statusCodeUpdateUETDSDanger = null
        },

        getSeferMaliyetDetayItem: (state, action) => {
            state.seferMaliyetDetayItem = action.payload
        },

        getDestekGeriBildirimDetay: (state,action) => {
            state.destekGeriBildirimDetayItem = action.payload
        },

        getGarajItemData: (state,action) => {
            state.garajItemData = action.payload
        },

        clearAdminState: (state) => {
           return initialState
        }
    },
    extraReducers:(builder)=> {
        builder

        // yeni yuk ekle
        .addCase(getUETDS.pending, (state)=> {
            state.statusCodeGetUETDS = null
            state.isLoading = true
        })

        .addCase(getUETDS.fulfilled, (state, action)=> {
            state.isLoading = false
            state.UETDSCount = action.payload.itemCount
            state.UETDSList = action.payload.uetdsData.$values
            state.statusCodeGetUETDS = action.payload.statusCode
        })

        .addCase(getUETDS.rejected, (state, action)=> {
            state.isLoading = false
            state.isError = true
        })

        // send U-ETDS
        .addCase(sendUETDS.pending, (state)=> {
            state.statusCodeSendUETDS = null
            state.isLoadingUETDSSend = true
        })

        .addCase(sendUETDS.fulfilled, (state, action)=> {
            state.isLoadingUETDSSend = false
            const id = action.payload.data.id
            state.UETDSList = state.UETDSList.filter((item)=> {
                return item.id !== id
            })
        })

        .addCase(sendUETDS.rejected, (state, action)=> {
            state.isLoadingUETDSSend = false
            state.isError = true
        })

        // create U-ETDS (normal)
        .addCase(addUETDS.pending, (state)=> {
            state.statusCodeAddUETDS = null
            state.isLoadingCreateUETDS = true
        })

        .addCase(addUETDS.fulfilled, (state, action)=> {
            state.isLoadingCreateUETDS = false
            state.statusCodeAddUETDS = action.payload.statusCode
        })

        .addCase(addUETDS.rejected, (state, action)=> {
            state.isLoadingCreateUETDS = false
            state.isError = true
        })

        // create U-ETDS (danger)
        .addCase(addUETDSDanger.pending, (state)=> {
            state.statusCodeAddUETDSDanger = null
            state.isLoadingCreateUETDS = true
        })

        .addCase(addUETDSDanger.fulfilled, (state, action)=> {
            state.isLoadingCreateUETDS = false
            state.statusCodeAddUETDSDanger = action.payload.statusCode
        })

        .addCase(addUETDSDanger.rejected, (state, action)=> {
            state.isLoadingCreateUETDS = false
            state.isError = true
        })

        // update U-ETDS
        .addCase(updateUETDS.pending, (state)=> {
            state.statusCodeUpdateUETDS = null
            state.isLoadingUpdateUETDS = true
        })

        .addCase(updateUETDS.fulfilled, (state, action)=> {
            state.isLoadingUpdateUETDS = false
            state.statusCodeUpdateUETDS = action.payload.statusCode
            const updatedYuk = action.payload.data
            state.UETDSList = state.UETDSList.map((item)=> {
                if(item.id === updatedYuk.id){
                    return updatedYuk
                } 
                return item
            })
        })

        .addCase(updateUETDS.rejected, (state, action)=> {
            state.isLoadingUpdateUETDS = false
            state.isError = true
        })

        // update U-ETDS (danger)
        .addCase(updateUETDSDanger.pending, (state)=> {
            state.statusCodeUpdateUETDSDanger = null
            state.isLoadingUpdateUETDS = true
        })

        .addCase(updateUETDSDanger.fulfilled, (state, action)=> {
            state.isLoadingUpdateUETDS = false
            state.statusCodeUpdateUETDSDanger = action.payload.statusCode
            const updatedYuk = action.payload.data
            state.UETDSList = state.UETDSList.map((item)=> {
                if(item.id === updatedYuk.id){
                    return updatedYuk
                } 
                return item
            })
        })

        .addCase(updateUETDSDanger.rejected, (state, action)=> {
            state.isLoadingUpdateUETDS = false
            state.isError = true
        })

        // update U-ETDS and SEnd
        .addCase(updateUETDSAndSend.pending, (state)=> {
            state.isLoadingUpdateUETDSAndSend = true
        })

        .addCase(updateUETDSAndSend.fulfilled, (state, action)=> {
            state.isLoadingUpdateUETDSAndSend = false
            state.UETDSList = state.UETDSList.filter(item => {
                return item.id !== action.payload.data.id
            })
            // const updatedYuk = action.payload.data
            // state.UETDSList = state.UETDSList.filter((item)=> {
            //     if(item.id === updatedYuk.id){
            //         return updatedYuk
            //     } 
            //     return item
            // })
        })

        .addCase(updateUETDSAndSend.rejected, (state, action)=> {
            state.isLoadingUpdateUETDSAndSend = false
        })

        .addCase(updateUETDSAndSendDanger.pending, (state)=> {
            state.isLoadingUpdateUETDSAndSend = true
        })

        .addCase(updateUETDSAndSendDanger.fulfilled, (state, action)=> {
            state.isLoadingUpdateUETDSAndSend = false
            state.UETDSList = state.UETDSList.filter(item => {
                return item.id !== action.payload.data.id
            })
            // const updatedYuk = action.payload.data
            // state.UETDSList = state.UETDSList.filter((item)=> {
            //     if(item.id === updatedYuk.id){
            //         return updatedYuk
            //     } 
            //     return item
            // })
        })

        .addCase(updateUETDSAndSendDanger.rejected, (state, action)=> {
            state.isLoadingUpdateUETDSAndSend = false
        })


        // delete U-ETDS
        .addCase(deleteUetds.pending, (state)=> {
            state.isLoadingDeleteUetds = true
        })

        .addCase(deleteUetds.fulfilled, (state, action)=> {
            state.isLoadingDeleteUetds = false
            const {id} = action.payload.data
            state.UETDSList = state.UETDSList.filter(item => item.id !== id)
            state.UETDSCount = state.UETDSCount -1
        })

        .addCase(deleteUetds.rejected, (state, action)=> {
            state.isLoadingDeleteUetds = false
        })

        // craete excel
        .addCase(getUetdsExcel.pending, (state)=> {
            state.isLoadingExcel = true
        })

        .addCase(getUetdsExcel.fulfilled, (state, action)=> {
            state.isLoadingExcel = false
        })

        .addCase(getUetdsExcel.rejected, (state, action)=> {
            state.isLoadingExcel = false
            state.isError = true
        })

        .addCase(getUetdsExcelSpecial.pending, (state)=> {
            state.isLoadingExcel = true
        })

        .addCase(getUetdsExcelSpecial.fulfilled, (state, action)=> {
            state.isLoadingExcel = false
        })

        .addCase(getUetdsExcelSpecial.rejected, (state, action)=> {
            state.isLoadingExcel = false
            state.isError = true
        })

        // get egeyurt iletisim
        .addCase(addEgeyurtIletisimItem.pending, (state)=> {
            state.isLoadingAddEgeyurtIletisimItem = true
        })

        .addCase(addEgeyurtIletisimItem.fulfilled, (state, action)=> {
            state.isLoadingAddEgeyurtIletisimItem = false
            const data = action.payload.data
            state.egeyurtIletisimList = [...state.egeyurtIletisimList, data]
        })

        .addCase(addEgeyurtIletisimItem.rejected, (state, action)=> {
            state.isLoadingAddEgeyurtIletisimItem = false
            state.isError = true
        })

        // get egeyurt iletisim
        .addCase(getEgeyurtIletisim.pending, (state)=> {
            state.isLoadingGetEgeyurtIletisim = true
        })

        .addCase(getEgeyurtIletisim.fulfilled, (state, action)=> {
            state.isLoadingGetEgeyurtIletisim = false
            state.egeyurtIletisimList = action.payload.data.$values

        })

        .addCase(getEgeyurtIletisim.rejected, (state, action)=> {
            state.isLoadingGetEgeyurtIletisim = false
            state.isError = true
        })

        // update  egeyurt iletisim
        .addCase(updateEgeyurtIletisimItem.pending, (state)=> {
            state.isLoadingUpdateEgeyurtIletisimItem = true
        })

        .addCase(updateEgeyurtIletisimItem.fulfilled, (state, action)=> {
            state.isLoadingUpdateEgeyurtIletisimItem = false
            const updatedBirim = action.payload.data
            state.egeyurtIletisimList = state.egeyurtIletisimList.map((item)=> {
                if(item.id === updatedBirim.id){
                    return updatedBirim
                } 
                return item
            })
        })

        .addCase(updateEgeyurtIletisimItem.rejected, (state, action)=> {
            state.isLoadingUpdateEgeyurtIletisimItem = false
            state.isError = true
        })

        // delete  egeyurt iletisim
        .addCase(deleteEgeyurtIletisimItem.pending, (state)=> {
            state.isLoadingDeleteEgeyurtIletisimItem = true
        })

        .addCase(deleteEgeyurtIletisimItem.fulfilled, (state, action)=> {
            state.isLoadingDeleteEgeyurtIletisimItem = false
            state.egeyurtIletisimList = state.egeyurtIletisimList.filter((item)=> {
                return item.id !== action.payload.data.id
            })
        })

        .addCase(deleteEgeyurtIletisimItem.rejected, (state, action)=> {
            state.isLoadingDeleteEgeyurtIletisimItem = false
            state.isError = true
        })

     

    // get fatura image
    .addCase(getFaturaImage.pending, (state)=> {
        state.isLoadingGetFaturaImage = true
    })

    .addCase(getFaturaImage.fulfilled, (state, action)=> {
        state.isLoadingGetFaturaImage = false
        state.faturaImage = action.payload.message
    })

    .addCase(getFaturaImage.rejected, (state, action)=> {
        state.isLoadingGetFaturaImage = false
        state.isError = true
    })

    //  Fatura Yükleme
    .addCase(faturaYukle.pending, (state)=> {
        state.isLoadingFaturaYukle = true
    })

    .addCase(faturaYukle.fulfilled, (state, action)=> {
        state.isLoadingFaturaYukle = false
    })

    .addCase(faturaYukle.rejected, (state, action)=> {
        state.isLoadingFaturaYukle = false
        state.isError = true
    })





    //  detay Yükleme
    .addCase(aracBelgeAktiflikKontrol.pending, (state)=> {
        state.isLoadingDetayYukle = true
    })

    .addCase(aracBelgeAktiflikKontrol.fulfilled, (state, action)=> {
        state.isLoadingDetayYukle = false
    })

    .addCase(aracBelgeAktiflikKontrol.rejected, (state, action)=> {
        state.isLoadingDetayYukle = false
        state.isError = true
    })

    //  get Anasayfa Duyurular
    .addCase(getAnasayfaDuyurular.pending, (state)=> {
        state.isLoadingGetAnasayfaDuyurular = true
    })

    .addCase(getAnasayfaDuyurular.fulfilled, (state, action)=> {
        state.anasayfaDuyurular = action.payload.data.$values
        state.isLoadingGetAnasayfaDuyurular = false
    })

    .addCase(getAnasayfaDuyurular.rejected, (state, action)=> {
        state.isLoadingGetAnasayfaDuyurular = false
        state.isError = true
    })

    //  get Anasayfa baslik
    .addCase(getAnaSayfaBaslik.pending, (state)=> {
        state.isLoadingGetAnasayfaBaslik = true
    })

    .addCase(getAnaSayfaBaslik.fulfilled, (state, action)=> {
        state.anasayfaBaslik = action.payload.data
        state.isLoadingGetAnasayfaBaslik = false
    })

    .addCase(getAnaSayfaBaslik.rejected, (state, action)=> {
        state.isLoadingGetAnasayfaBaslik = false
        state.isError = true
    })

    //  update baslik
    .addCase(updateAnasayfaBaslik.pending, (state)=> {
        state.isLoadingUpdateAnasayfaBaslik = true
    })

    .addCase(updateAnasayfaBaslik.fulfilled, (state, action)=> {
        state.anasayfaBaslik = action.payload.data
        state.isLoadingUpdateAnasayfaBaslik = false

    })

    .addCase(updateAnasayfaBaslik.rejected, (state, action)=> {
        state.isLoadingUpdateAnasayfaBaslik = false
        state.isError = true
    })

    //  create anasayfa Duyuru
    .addCase(createAnasayfaDuyuru.pending, (state)=> {
        state.isLoadingCreateAnasayfaDuyuru = true
    })

    .addCase(createAnasayfaDuyuru.fulfilled, (state, action)=> {
        state.isLoadingCreateAnasayfaDuyuru = false
        const duyuru = action.payload.data
        state.anasayfaDuyurular = [...state.anasayfaDuyurular, duyuru]

    })

    .addCase(createAnasayfaDuyuru.rejected, (state, action)=> {
        state.isLoadingCreateAnasayfaDuyuru = false
        state.isError = true
    })

    //  update anasayfa Duyuru
    .addCase(updateAnasayfaDuyuru.pending, (state)=> {
        state.isLoadingUpdateAnasayfaDuyuru = true
    })

    .addCase(updateAnasayfaDuyuru.fulfilled, (state, action)=> {
        state.isLoadingUpdateAnasayfaDuyuru = false
        state.anasayfaDuyurular = state.anasayfaDuyurular.map((item)=> {
            if(item.id === action.payload.data.id){
                return action.payload.data
            }
            return item
        })
    })

    .addCase(updateAnasayfaDuyuru.rejected, (state, action)=> {
        state.isLoadingUpdateAnasayfaDuyuru = false
        state.isError = true
    })

    //  delete anasayfa Duyuru
    .addCase(deleteAnasayfaDuyuru.pending, (state)=> {
        state.isLoadingDeleteAnasayfaDuyuru = true
    })

    .addCase(deleteAnasayfaDuyuru.fulfilled, (state, action)=> {
        state.isLoadingDeleteAnasayfaDuyuru = false
        const deletedDuyuru = action.payload.data
        state.anasayfaDuyurular = state.anasayfaDuyurular.filter((item)=> {
            return item.id !== deletedDuyuru.id
        })
    })

    .addCase(deleteAnasayfaDuyuru.rejected, (state, action)=> {
        state.isLoadingDeleteAnasayfaDuyuru = false
        state.isError = true
    })

    //  get garaj yoğunluk
    .addCase(getGarajYogunluk.pending, (state)=> {
        state.isLoadingGetGarajYogunluk = true
    })

    .addCase(getGarajYogunluk.fulfilled, (state, action)=> {
        state.isLoadingGetGarajYogunluk = false
        state.garajYogunlukList = action.payload.data.$values
    })

    .addCase(getGarajYogunluk.rejected, (state, action)=> {
        state.isLoadingGetGarajYogunluk = false
        state.isError = true
    })

    //  get get garaj detay
    .addCase(getGarajDetay.pending, (state)=> {
        state.isLoadingGarajDetay = true
    })

    .addCase(getGarajDetay.fulfilled, (state, action)=> {
        state.isLoadingGarajDetay = false
        state.garajDetayData = action.payload.data.$values
    })

    .addCase(getGarajDetay.rejected, (state, action)=> {
        state.isLoadingGarajDetay = false
        state.isError = true
    })

    //  update garaj stats
    .addCase(updateGarajStats.pending, (state)=> {
        state.isLoadingGarajDetay = true
    })

    .addCase(updateGarajStats.fulfilled, (state, action)=> {
        state.isLoadingGarajDetay = false
        const data = {branchId: action.payload.data.branchId, branchName: action.payload.data.branch.name, entryTime: action.payload.data.entryTime, loadDensity: action.payload.data.loadDensity, vehicleDensity: action.payload.data.vehicleDensity }
        state.isUpdatedGarajDetay = true

        // state.garajYogunlukList = state.garajYogunlukList.map((item) => {
        //     // console.log(item.branchId);
        //     if(item.branchId === data.branchId){
        //         return data
        //     }
        //     else{
        //         return item
        //     }
        // })
    })

    .addCase(updateGarajStats.rejected, (state, action)=> {
        state.isLoadingGarajDetay = false
        state.isError = true
    })

    }
})


export const {getUETDSItemData,getEgeyurtIletisimItemData,getAnasayfaDuyuruMessageItemData, resetStatusCode, clearAdminState, getSeferMaliyetDetayItem, getDestekGeriBildirimDetay, getGarajItemData } = adminSlice.actions
export default adminSlice.reducer